import React from 'react';
import {MasterLayout} from 'layout';
import {DanhSachDoiTuongTrung} from 'modules/thanh-tra';

export default class DanhSachDoiTuongTrungPage extends React.Component {
  
  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <DanhSachDoiTuongTrung/>
      </MasterLayout>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/pages/thanh-tra/DanhSachDoiTuongTrungPage.jsx